export default __webpack_public_path__ + "static/media/children_with_nurse_playroom2.a8b14d03.png";